import { bottomPropertyTypeCodes, topPropertyTypeCodes } from './propertyTypeConfig';
import { currencyCodes } from '../currencyConfig';

const APARTMENT_PROPERTY_TYPE = '16';
const CONDO_PROPERTY_TYPE = '7';
const APART_HOTEL_PROPERTY_TYPE = '22';
const PRIVATE_VACATION_HOME_PROPERTY_TYPE = '17';
const CONDOMINIUM_PROPERTY_TYPE = '23';
const RESIDENCE_PROPERTY_TYPE = '33';
const CABIN_PROPERTY_TYPE = '9';
const CHALET_PROPERTY_TYPE = '10';
const COTTAGE_PROPERTY_TYPE = '11';
const VILLA_PROPERTY_TYPE = '14';
const BOAT_PROPERTY_TYPE = '18';

const getTypeOptions = (props) => {
    const { translations } = props;
    const getOptionText = (code) => translations.getTranslation(`propertyType.${code}`);

    const topOptions = topPropertyTypeCodes.map(
        (code) => ({ value: code, text: getOptionText(code) })
    );

    const bottomOptions = bottomPropertyTypeCodes.map(
        (code) => ({ value: code, text: getOptionText(code) })
    );

    return [
        { value: '', text: translations.getTranslation('propertyType.select') },
        ...topOptions,
        { value: '---', text: '---   ---', disabled: true },
        ...bottomOptions
    ];
};

const getFullCurrencyList = (props) => {
    const { translations, currencyList } = props;
    if (currencyList.success === true) {
        if (currencyList && !currencyList.values) {
            currencyCodes.sort((a, b) => a - b);
            const currencyTypes = currencyCodes.map((code) => ({ value: code, text: translations.getTranslation(`currency${code}`) }));
            return [
                { value: '', text: translations.getTranslation('currency.select') },
                ...currencyTypes
            ];
        }
        [...currencyList.values].sort((a, b) => a - b);
        const currencyTypes = currencyList.values.map((code) => ({ value: code, text: translations.getTranslation(`currency${code}`) }));

        return [
            { value: '', text: translations.getTranslation('currency.select') },
            ...currencyTypes
        ];
    }
    return [];
};

const getUnitCountLabel = (propertyType) => {
    switch (propertyType) {
    case APARTMENT_PROPERTY_TYPE:
    case APART_HOTEL_PROPERTY_TYPE:
        return 'unitCount.apartmentLabelText';
    case CONDO_PROPERTY_TYPE:
    case CONDOMINIUM_PROPERTY_TYPE:
        return 'unitCount.condosLabelText';
    case PRIVATE_VACATION_HOME_PROPERTY_TYPE:
    case RESIDENCE_PROPERTY_TYPE:
        return 'unitCount.homeLabelText';
    case CABIN_PROPERTY_TYPE:
        return 'unitCount.cabinLabelText';
    case CHALET_PROPERTY_TYPE:
        return 'unitCount.chaletLabelText';
    case COTTAGE_PROPERTY_TYPE:
        return 'unitCount.cottageLabelText';
    case VILLA_PROPERTY_TYPE:
        return 'unitCount.villaLabelText';
    case BOAT_PROPERTY_TYPE:
        return 'unitCount.boatLabelText';
    default:
        return 'property.unitCount';
    }
};

export { getTypeOptions, getFullCurrencyList, getUnitCountLabel };
